'use client';

import { c as _c } from "react/compiler-runtime";
import { TopNavAccountPanel } from '@src/components/TopNavV4/TopNavAccountPanel/TopNavAccountPanel';
import { TopNavProvider } from '@src/components/TopNavV4/TopNavContext';
import { defaultTopNavProps } from './TopNav.defaults';
import { TopNavDesktop } from './TopNavDesktop/TopNavDesktop';
import { TopNavMobile } from './TopNavMobile/TopNavMobile';
import { type TopNavProps } from './TopNavProps';
export const TopNavV4 = t0 => {
  const $ = _c(5);
  const props = t0 === undefined ? defaultTopNavProps : t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <TopNavMobile />;
    t2 = <TopNavDesktop />;
    t3 = <TopNavAccountPanel />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== props) {
    t4 = <TopNavProvider topNavProps={props}>{t1}{t2}{t3}</TopNavProvider>;
    $[3] = props;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};